import { AfterContentInit, Component, ElementRef, Input, OnDestroy, ViewChild, inject } from '@angular/core';
import { MapService } from '@maplibre/ngx-maplibre-gl';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { HomeControl } from './home-control';
import { LngLat } from 'maplibre-gl';
import { IonicModule } from '@ionic/angular';

@Component({
    selector: 'app-map-control-home',
    template: `
    <div class="maplibregl-ctrl maplibregl-ctrl-group home" #content>
      <button (click)="centerCampus()">
        <span id="home-label" style="display:none;">{{ 'campus-navi.home' | translate }}</span>
        <ion-icon name="home" size="large" aria-labelledby="home-label"></ion-icon>
      </button>
    </div>
  `,
    styleUrls: ['./home.component.scss'],
    imports: [IonicModule, TranslatePipe]
})
export class HomeControlComponent implements AfterContentInit, OnDestroy {
  private mapService = inject(MapService);
  translate = inject(TranslateService);

  @Input() 
  public position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';

  @ViewChild('content', { static: true }) content: ElementRef;

  private control: HomeControl;

  public expanded = false;

  ngAfterContentInit() {
    if (this.content.nativeElement.childNodes.length) {
      this.control = new HomeControl(this.content.nativeElement);

      this.mapService.mapCreated$.subscribe(() => {
        this.mapService.addControl(this.control, this.position);
      });
    }
  }

  ngOnDestroy() {
    if (this.mapService.mapInstance.hasControl(this.control)) {
      this.mapService.removeControl(this.control);
    }
  }

  public centerCampus() {
    this.mapService.mapInstance.flyTo({ center: new LngLat(7.4128, 51.4875), zoom: 14 });
  }
}
